import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "grid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_footerLinks = _resolveComponent("footerLinks")!
  const _component_socialMedia = _resolveComponent("socialMedia")!
  const _component_gambleAware = _resolveComponent("gambleAware")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_footerLinks),
        _createVNode(_component_socialMedia),
        _createElementVNode("p", null, [
          _createElementVNode("small", null, "© Copyright 2018 " + _toDisplayString(_ctx.addressCompanyName) + ". Registered in England and Wales No. " + _toDisplayString(_ctx.addressCompanyRegistrationNumber) + ". All rights reserved. Address for all correspondence and queries: " + _toDisplayString(_ctx.addressCompanyName) + ", First Floor, Unit 4 Faraday Court, Centrum 100 Business Park, First Ave, Burton-Upon-Trent, Staffordshire, DE14 2WX. Registered under the Data Protection Act." + _toDisplayString(_ctx.addressCompanyName) + " - Registration No.Z2953491.", 1)
        ]),
        _createVNode(_component_gambleAware)
      ])
    ])
  ]))
}